const lbGray = {
  50: '#FFFFFF',
  100: '#F8F8F9',
  200: '#F0F1F3',
  300: '#D6D9DD',
  400: '#AAB1BA',
  500: '#888F9B',
  600: '#707783',
  700: '#4F565F',
  800: '#2F333A',
  900: '#1C1E23',
  A100: '#08090B',
  A200: '#000000',
};

export default lbGray;
